// Shared mock data used across blog, resources, and other sections

// Mock Images
// Mock image URLs for blog posts and content
export const mockImages = {
  // Creative/Marketing focused images
  creative: {
    wide: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Team brainstorming
    wide2: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Creative meeting
    wide3: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Creative workspace
    wide4: 'https://images.unsplash.com/photo-1531403009284-440f080d1e12?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Design thinking
    square: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80', // Creative desk setup
    square2: 'https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80', // Creative tools
    square3: 'https://images.unsplash.com/photo-1517697471339-4aa32003c11a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80', // Creative process
    square4: 'https://images.unsplash.com/photo-1513542789411-b6a5d4f31634?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80', // Design elements
    vertical: 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80', // Team meeting
    vertical2: 'https://images.unsplash.com/photo-1531538606174-0f90ff5dce83?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80', // Creative portrait
    vertical3: 'https://images.unsplash.com/photo-1517433456452-f9633a875f6f?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80', // Creative workspace vertical
    vertical4: 'https://images.unsplash.com/photo-1517502884422-41eaead166d4?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80', // Creative process vertical
    testing: {
      dashboard1: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Testing dashboard 1
      dashboard2: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Testing dashboard 2
      charts1: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Testing charts 1
      charts2: 'https://images.unsplash.com/photo-1531403009284-440f080d1e12?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80' // Testing charts 2
    }
  },
  
  // Analytics/Data focused images
  analytics: {
    wide: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Data visualization
    wide2: 'https://images.unsplash.com/photo-1518186285589-2f7649de83e0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Data analysis
    wide3: 'https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Data science
    wide4: 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Analytics team
    square: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80', // Analytics dashboard
    square2: 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80', // Data charts
    square3: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80', // Data insights
    square4: 'https://images.unsplash.com/photo-1518186285589-2f7649de83e0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80', // Analytics tools
    vertical: 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80', // Data center
    vertical2: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80', // Data analysis vertical
    vertical3: 'https://images.unsplash.com/photo-1518186285589-2f7649de83e0?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80', // Analytics workspace
    vertical4: 'https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80', // Data science vertical
  },

  // AI/Technology focused images  
  technology: {
    wide: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // AI visualization
    wide2: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Technology interface
    wide3: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // AI technology
    wide4: 'https://images.unsplash.com/photo-1515378960530-7c0da6231fb1?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Digital technology
    square: 'https://images.unsplash.com/photo-1677442136728-6e50dd21d032?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80', // Robot/AI
    square2: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80', // Tech interface
    square3: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80', // AI systems
    square4: 'https://images.unsplash.com/photo-1515378960530-7c0da6231fb1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80', // Digital tech
    vertical: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80', // Tech/circuits
    vertical2: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80', // Technology vertical
    vertical3: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80', // AI vertical
    vertical4: 'https://images.unsplash.com/photo-1515378960530-7c0da6231fb1?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80', // Digital vertical
  },

  // Business/Strategy focused images
  business: {
    wide: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Office meeting
    wide2: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Business conference
    wide3: 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Strategy session
    wide4: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Business planning
    square: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80', // Modern building
    square2: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80', // Business meeting
    square3: 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80', // Strategy planning
    square4: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80', // Business strategy
    vertical: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80', // Business handshake
    vertical2: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80', // Business vertical
    vertical3: 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80', // Strategy vertical
    vertical4: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80', // Planning vertical
  },

  // Utility images for general use
  utility: {
    // People and faces
    faces: {
      diverse1: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=988&q=80', // Professional woman
      diverse2: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=988&q=80', // Professional man
      diverse3: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=988&q=80', // Business portrait
      team1: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Diverse team
      team2: 'https://images.unsplash.com/photo-1556761175-4b46a572b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80' // Team collaboration
    },
    
    // Abstract patterns and textures
    patterns: {
      geometric1: 'https://images.unsplash.com/photo-1477346611705-65d1883cee1e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Geometric pattern
      geometric2: 'https://images.unsplash.com/photo-1477346611705-65d1883cee1e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Abstract geometry
      texture1: 'https://images.unsplash.com/photo-1558591710-4b4a1ae0f04d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Subtle texture
      gradient1: 'https://images.unsplash.com/photo-1557683316-973673baf926?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80' // Color gradient
    },

    // Metrics and data visualization
    metrics: {
      charts1: 'https://images.unsplash.com/photo-1543286386-713bdd548da4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Business charts
      dashboard1: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Analytics dashboard
      growth1: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Growth chart
      stats1: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80' // Statistics visualization
    }
  }
} as const

// Shared mock authors that can be used across blog posts, resources, etc.
export const mockAuthors = {
  morgan: {
    name: 'Morgan Titcher',
    role: 'Founder & CEO',
    href: '/team/morgan',
    imageUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    bio: 'Founder of AdSights, focused on revolutionizing creative analytics.',
    socialLinks: {
      twitter: 'https://twitter.com/morgantitcher',
      linkedin: 'https://linkedin.com/in/morgantitcher'
    }
  },
  sarah: {
    name: 'Sarah Chen',
    role: 'Head of Product',
    href: '/team/sarah',
    imageUrl: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    bio: 'Product leader with expertise in AI and analytics platforms.',
    socialLinks: {
      linkedin: 'https://linkedin.com/in/sarahchen'
    }
  },
  alex: {
    name: 'Alex Rodriguez',
    role: 'Creative Director',
    href: '/team/alex',
    imageUrl: 'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    bio: 'Creative director with 10+ years in digital advertising.',
    socialLinks: {
      twitter: 'https://twitter.com/alexr',
      linkedin: 'https://linkedin.com/in/alexr'
    }
  }
} as const

// Shared categories that can be used across different content types
export const sharedCategories = {
  creativeStrategy: {
    title: 'Creative Strategy',
    href: '/category/creative-strategy',
    description: 'Insights and strategies for better creative performance',
    featured: true
  },
  aiAnalytics: {
    title: 'AI & Analytics',
    href: '/category/ai-analytics', 
    description: 'Latest developments in AI-powered creative analytics',
    featured: true
  },
  caseStudies: {
    title: 'Case Studies',
    href: '/category/case-studies',
    description: 'Real-world examples and success stories',
    featured: false
  },
  industryInsights: {
    title: 'Industry Insights',
    href: '/category/industry-insights',
    description: 'Trends and analysis in digital advertising',
    featured: false
  }
} as const

// Shared difficulty levels
export const difficultyLevels = [
  'beginner',
  'intermediate', 
  'advanced'
] as const

// Shared platforms
export const platforms = [
  'Meta',
  'TikTok',
  'Google',
  'Snapchat'
] as const
